import React, { Component } from 'react';

import format from '../../utility/format';

import '../../components/PrintTable.css';

export default class RemainderAnnuityTrustPrint extends Component {

    render() {
        var params = this.props.params;
        var result = this.props.result;
        var clientDefaults = this.props.clientDefaults;
        var organization = clientDefaults.organizationName;

        var payout = null;
        if (params.trustType === 'fixed') {
            payout = (<div>
                <dt>Trust's Total Payment to You</dt><dd>{ format.dollars(result.totalPayment) }</dd>
            </div>);

        } else {
            payout = (<div>
                <dt>Trust's First-Year Payment to You</dt><dd>{ format.dollars(result.firstYearPayment) }</dd>
            </div>);
        }

        var term = null;
        if (params.type === 'fixed') {
            term = (<div>
                <dt>Number of Years</dt><dd>{ params.years }</dd>
            </div>);
        }

        var age1 = null;
        if (params.type === 'single' || params.type === 'double') {
            age1 = (<div>
                <dt>Your Age</dt><dd>{ params.age1 }</dd>
            </div>);
        }

        var age2 = null;
        if (params.type === 'double') {
            age2 = (<div>
                <dt>Other Person's Age</dt><dd>{ params.age2 }</dd>
            </div>);
        }

        return (<div>
            <div className="org-print-date-row">
                <div className="org-name">{ organization }</div>
                <div className="print-date">{ format.printDateFormat() }</div>
            </div>

            <div className="print-table">
                <div className="print-header">Summary of Benefits:</div>
                <dl className="print-rows">
                    <div>
                        <dt>Estimated Amount to { organization }</dt><dd>{ format.dollars(result.charitableGiftValue) }</dd>
                    </div>
                    { payout }
                    <div>
                        <dt>Potential Tax Deduction</dt><dd>{ format.dollars(result.charitableTaxDeduction) }</dd>
                        <div className="CMFR-print-disclaimer">*Based on a {format.percent(clientDefaults.rate)} charitable midterm federal rate.</div>
                    </div>
                </dl>
            </div>

            <div className="print-table">
                <div className="print-header">Assumptions:</div>
                <dl className="print-rows">
                    <div>
                        <dt>Your Gift</dt><dd>{ format.dollars(params.giftAmount) }</dd>
                    </div>
                    <div>
                        <dt>Trust Duration</dt><dd>{ {
                            'fixed': 'Fixed Number of Years',
                            'single': 'Rest of Your Life',
                            'double': 'Rest of Your or Another Person\'s Life',
                        }[params.type] }</dd>
                    </div>
                    { term }
                    { age1 }
                    { age2 }
                    <div>
                        <dt>Trust Type</dt><dd>{ {
                            'fixed': 'Fixed Payments',
                            'variable': 'Variable Payments (Unitrust)',
                        }[params.trustType] }</dd>
                    </div>
                    <div>
                        <dt>Payout Rate</dt><dd>{ format.percent(params.payoutRate) }</dd>
                    </div>
                </dl>
            </div>
        </div>);
    }

}
